// extracted by css-extract-rspack-plugin
export default {"cls1":"CoScientistLandingPage-cls1_NPN","cls2":"CoScientistLandingPage-cls2_IJL CoScientistLandingPage-cls1_NPN"};